module.exports = __webpack_public_path__ + "img/chart-title.dbbbe6a1.png";